import React from "react";
import { Stepper } from "cxa-components";
import FormField from "./FormField";

const NumberField = props =>
  <FormField
    component={Stepper}
    boxed
    type="number"
    {...props}
    pattern="\d*"
  />;

export default NumberField;



// WEBPACK FOOTER //
// ./components/common/form-field/NumberField.js